import {Modal} from 'antd';

export default (message, type) => {
    let secondsToGo = 5;
    let autoTimeout = true;
    const modal = Modal[type]({
        title: message,
        content: !autoTimeout ? `${secondsToGo}` : '',
    });
    const timer = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
            content: `${secondsToGo}`,
        });
    }, 1000);
    autoTimeout && setTimeout(() => {
        clearInterval(timer);
        modal.destroy();
    }, secondsToGo * 1000);
};

// ReactDOM.render(<Button onClick={countDown}>Open modal to close in 5s</Button>, mountNode);